import { QRCodeSVG } from 'qrcode.react';
import { createPortal } from 'react-dom';
import styles from './Badge.module.css';

// ── Escarapela ─────────────────────────────────────────────────────────────────
export default function Badge({ guest, event, company, onClose }) {
  const year = new Date().getFullYear();
  const fmt  = (d) => d ? new Date(d).toLocaleDateString('es-CO', { day:'2-digit', month:'long', year:'numeric' }) : '';

  const handlePrint = () => window.print();

  return createPortal(
    <div className={styles.fondo}>

      {/* Controles — esquina superior derecha */}
      <div className={styles.controles}>
        <button onClick={handlePrint}
          className={styles.botonImprimir}>
          <i className={`fas fa-print ${styles.botonImprimirIcono}`} />
          Imprimir escarapela
        </button>
        <button onClick={onClose}
          className={styles.botonCerrar}>✕</button>
      </div>

      {/* Escarapela */}
      <div id="badge-print" className={styles.escarapela}>
        {/* Banda superior degradada */}
        <div className={styles.banda} />

        {/* Header con logo empresa */}
        <div className={styles.cabecera}>
          <div className={styles.empresa}>
            {company?.name || ''}
          </div>
          <div className={styles.evento}>
            {event?.name || ''}
          </div>
          {event?.start_time && (
            <div className={styles.fecha}>
              {fmt(event.start_time)}
            </div>
          )}
          {event?.address && (
            <div className={styles.direccion}>
              <i className={`fas fa-map-marker-alt ${styles.direccionIcono}`} />
              {event.address}
            </div>
          )}
        </div>

        {/* Avatar */}
        <div className={styles.avatarCaja}>
          <div className={styles.avatar}>
            {(guest?.name || 'G')[0].toUpperCase()}
          </div>
        </div>

        {/* Nombre */}
        <div className={styles.persona}>
          <div className={styles.nombre}>
            {guest?.name || ''}
          </div>
          {guest?.position_company && (
            <div className={styles.cargo}>
              {guest.position_company}
            </div>
          )}
          {guest?.company && (
            <div className={styles.empresaInvitado}>
              {guest.company}
            </div>
          )}
        </div>

        {/* Documento */}
        {guest?.number && (
          <div className={styles.documento}>
            <span className={styles.documentoTipo}>
              {guest.type_identification || 'CC'}
            </span>
            <span className={styles.documentoNumero}>
              {guest.number}
            </span>
          </div>
        )}

        {/* QR — referencia opaca (guestId + eventId), sin datos personales
            (POD-05), firmada con qr_signature (calculada por el backend con
            utils/qrSign.js) para que el check-in por cámara pueda verificar
            que el QR viene realmente del servidor y no fue fabricado. */}
        {(() => {
          const qrData = JSON.stringify({
            guestId:   guest?.id,
            eventId:   event?.id,
            signature: guest?.qr_signature,
          });
          return (
            <div className={styles.qr}>
              <QRCodeSVG
                value={qrData}
                size={110}
                bgColor="#ffffff"
                fgColor="#1a1d2e"
                level="M"
                includeMargin={false}
              />
            </div>
          );
        })()}

        {/* Acceso */}
        <div className={styles.acceso}>
          ✓ Acceso autorizado
        </div>

        {/* Spacer */}
        <div className={styles.relleno} />

        {/* Banda inferior — marca de agua */}
        <div className={styles.pie}>
          <span className={styles.pieTexto}>
            Generado por EVENTIFY · {year}
          </span>
        </div>
      </div>

      <style>{`
        @media print {
          /* Se oculta todo hijo de <body> que NO contiene la escarapela (antes se ocultaba también el contenedor de la propia escarapela y salía en blanco) */
          body > *:not(:has(#badge-print)) { display: none !important; }
          #badge-print { box-shadow: none !important; }
        }
      `}</style>
    </div>,
    document.body
  );
}
